import AMPCompliance from "./amp/containers";
import HTComponent from "./ht/containers";
import ADComponent from "./ad/containers";
import OccmComponents from "./occm/containers";
import SbComponents from "./sb/containers";
import pageLayoutHoc from "../../hocs/pageLayoutHoc";
import userRoleBaseAccessHoc from "../../hocs/userRoleBaseAccessHoc";
import ModsComponents from "./mods/containers";
import SRComponent from "./sr/containers";
import LLPComponents from "./llp/containers/index.js";
import ShopVisitComponents from './shopVisit/containers/index.js'
import MainInventory from "./inventory/containers/index.js";
import MainUtilization from "./utilization/containers/index.js"
import SoftTimeComponent from "./softTime/containers"
import OpHistoryComponents from './opHistory/containers'
import MasterListComponent from "./masterComponent/containers/index.js";
import BasicDetailHeader from "./BasicDetailHeader.js";
import EngineModuleComponent from "./engineModule/containers";
export const camoRoutes = [
	{
		path: "/:asset/:assetType/tech_spec/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(BasicDetailHeader, ['asset_management','R']), {
			apps: "tech_spec",
			layoutPhase: 2,
		}),
		key: "tech_spec",
	},
	{
		path: "/:asset/:assetType/op_history/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(OpHistoryComponents, ['utilization','R']), {
			apps: "Op",
			layoutPhase: 2,
		}),
		key: "Op",
	},
	{
		path: "/:asset/:assetType/amp/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(AMPCompliance, ['amp_compliance','R']), {
			apps: "AMP",
			layoutPhase: 2,
		}),
		key: "AMP",
	},
	{
		path: "/:asset/:assetType/ht/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(HTComponent, ['ht_component','R']), {
			apps: "HT",
			layoutPhase: 2,
		}),
		key: "HT",
	},
	{
		path: "/:asset/:assetType/ad/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(ADComponent, ['ad_status','R']), {
			apps: "AD",
			layoutPhase: 2,
		}),
		key: "AD",
	},

	{
		path: "/:asset/:assetType/occm/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(OccmComponents, ['occm_component','R']), {
			apps: "OCCM",
			layoutPhase: 2,
		}),
		key: "OCCM",
	},
	{
		path: "/:asset/:assetType/sb/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(SbComponents, ['sb_status','R']), {
			apps: "SB",
			layoutPhase: 2,
		}),
		key: "SB",
	},

	{
		path: "/:asset/:assetType/mods/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(ModsComponents, ['mod_status','R']), {
			apps: "MODS",
			layoutPhase: 2,
		}),
		key: "MODS",
	},
	{
		path: "/:asset/:assetType/sr/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(SRComponent, ['repair','R']), {
			apps: "SR",
			layoutPhase: 2,
		}),
		key: "SR",
	},

	{
		path: "/:asset/:assetType/llp/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(LLPComponents, ['utilization','R']), {
			apps: "LLP",
			layoutPhase: 2,
		}),
		key: "LLP",
	},
	{
		path: "/:asset/:assetType/shopVisit/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(ShopVisitComponents, ['utilization','R']), {
			apps: "sv",
			layoutPhase: 2,
		}),
		key: "sv",
	},
	{
		path: "/:asset/:assetType/inventory/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(MainInventory, ['utilization','R']), {
			apps: "MainInventory",
			layoutPhase: 2,
		}),
		key: "MainInventory",
	},

	{
		path: "/:asset/:assetType/utilization/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(MainUtilization, ['utilization','R']), {
			apps: "MainUtilization",
			layoutPhase: 2,
		}),
		key: "MainUtilization",
	},
	{
		path: "/:asset/:assetType/softTime/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(SoftTimeComponent, ['utilization','R']), {
			apps: "SoftTimeComponent",
			layoutPhase: 2,
		}),
		key: "SoftTimeComponent",
	},
	{
		path: "/:asset/:assetType/master_components/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(MasterListComponent, ['utilization','R']), {
			apps: "MC",
			layoutPhase: 2,
		}),
		key: "MC",
	},
		{
		path: "/:asset/:assetType/engine_module/list",
		component: pageLayoutHoc(userRoleBaseAccessHoc(EngineModuleComponent, ['utilization','R']), {
			apps: "engine",
			layoutPhase: 2,
		}),
		key: "engine",
	},
	

];
